import { useBrandContext } from 'context/BrandProvider';

const ThemeDesigner = () => {
  const { previewRef } = useBrandContext();
  return (
    <div className="h-full w-full bg-background-base-surface-1">
      <div className="h-full w-full scale-x-[0.96] scale-y-[0.93]">
        <iframe
          ref={previewRef}
          id="g360Preview"
          src={`${window.location.origin}/white-label`}
          className="h-full w-full rounded border border-stroke-base-subdued"
        />
      </div>
    </div>
  );
};

export default ThemeDesigner;
